import React, {useState} from 'react';
import {Upload} from 'antd';
import iconAdd from '../../../../assets/images/icon_add.png';
import iconDel from '../../../../assets/images/icon_shadow_close.png';
import {aiimgClickScriptEntryLog, clickBgUploadLog} from '../../../../log/ubcLog';

const ImageItem = props => {
    const {name, url, poster, type, bgTab, id, onSelect, opt, onUpload, onDel, setHashMenu} = props;
    const {delApi} = opt || {};

    const [materialSize, setMaterialSize] = useState({});
    const [showDelMask, setShowDelMask] = useState(false);

    const handleOnload = e => {
        try {
            const {width, height} = e.target;
            setMaterialSize({width, height});
        } catch (e) {
            // noop
        }
    };

    const del = async e => {
        e.stopPropagation();

        typeof onDel === 'function' && onDel(id);
        setShowDelMask(false);
    };

    const cancel = e => {
        e.stopPropagation();
        setShowDelMask(false);
    };

    const onClickDel = e => {
        e.stopPropagation();

        setShowDelMask(true);
    };

    const onClick = e => {
        onSelect({...props, materialSize});
    };

    const handleUpload = e => {
        clickBgUploadLog('bg_img');
        onUpload(e);
    };

    const goAIGCImg = () => {
        setHashMenu('aiimg');
        aiimgClickScriptEntryLog();
    };

    if (type === 'aigc') {
        return (
            <div className="digital-resource-lib-item image-item" onClick={goAIGCImg}>
                <div className="image-item-imgwrapper add">
                    <img className="icon icon-add" src={iconAdd} />
                    <p className="add-text">智能生成图片</p>
                </div>
            </div>
        );
    }

    if (type === 'add') {
        return (
            <div className="digital-resource-lib-item image-item">
                <Upload
                    customRequest={handleUpload}
                    showUploadList={false}
                    accept={opt.fileFilter || 'image/png,image/jpeg,image/jpg'}
                >
                    <div className="image-item-imgwrapper add">
                        <img className="icon icon-add" src={iconAdd} />
                        <p className="add-text">本地文件上传</p>
                    </div>
                </Upload>
            </div>
        );
    }

    return (
        <div className="digital-resource-lib-item image-item" onClick={onClick}>
            <div className="image-item-imgwrapper">
                <img className="image-item-img" src={bgTab === 'bg_video' ? poster : url} onLoad={handleOnload} />
                {delApi && !showDelMask ? <img className="icon icon-del" src={iconDel} onClick={onClickDel} /> : null}
                {showDelMask ? (
                    <div className="image-item-del-mask">
                        <p className="image-item-del-mask-title">确认删除吗?</p>
                        <div className="row">
                            <p className="image-item-del-mask-btn" onClick={cancel}>取消</p>
                            <p className="image-item-del-mask-btn" onClick={del}>确认</p>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ImageItem;
